import { render, staticRenderFns } from "./DetalleVenta.vue?vue&type=template&id=6b7bc0a3&"
import script from "./DetalleVenta.vue?vue&type=script&lang=ts&"
export * from "./DetalleVenta.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleVenta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b7bc0a3', component.options)
    } else {
      api.reload('6b7bc0a3', component.options)
    }
    module.hot.accept("./DetalleVenta.vue?vue&type=template&id=6b7bc0a3&", function () {
      api.rerender('6b7bc0a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasCrm/DetalleVenta.vue"
export default component.exports